import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {ProductsService, RootService, CustomerService} from 'src/app/services';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {capitalizeFirstLetter, removeAllSpacingBetweenWords} from '../../../../helpers';
import {getDateHelper} from "../../../../shared/common/helper";

@Component({
  selector: 'app-customers-group-add',
  templateUrl: './customers-group-add.component.html',
  styleUrls: ['./customers-group-add.component.scss']
})
export class CustomersGroupAddComponent implements OnInit {
  unsubscribe$ = new Subject<void>();
  show = false;
  // select product
  productValue = '1';
  showInputProduct = false;
  listOfSelectedValueProduct = [];
  productName = '';
  total;
  products = [];
  isLoading = false;
  searchProductChange$ = new BehaviorSubject('');
  // end select product

  // select khu vuc
  cityValue = '1';
  showInputCity = false;
  cities = [];
  listOfSelectedValueCity = [];
  // end select khu vuc
  validName = false;
  messageName$;
  validProduct = false;
  messageProduct$;
  validCity = false;
  messageCity$;
  @Output() emitData = new EventEmitter();
  loading = false;
  constructor(
    private fb: FormBuilder,
    private  productsService: ProductsService,
    private notification: NzNotificationService,
    private rootService: RootService,
    private customerService: CustomerService,
  ) {
    // @ts-ignore
    const optionListProduct$: Observable<string> = this.searchProductChange$
      .asObservable()
      .pipe(debounceTime(500));
    optionListProduct$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      // @ts-ignore
      // tslint:disable-next-line:triple-equals
      if (this.productValue == 2) {

        const query = {
          product_name: value.trim(),
          page: 1,
          page_size: 50
        };
        this.productsService.getAll(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
          (res) => {
            const data = res.data.items;
            if (data != null) {
              data.map(item => {
                const product = {
                  id: undefined,
                  name: undefined
                };
                if (item.productName) {
                  product.id = item.productId;
                  product.name = item.productName + ' ' + '(' + item.barcode + ')';
                } else {
                  product.id = item.productId;
                  product.name = '(' + item.barcode + ')';
                }
                this.products.push(product);
              });
            }
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
            this.products = [];
          }
        );
      }
    });

  }

  // tslint:disable-next-line:variable-name
  form_create = this.fb.group({
    name: ['', [Validators.required]],
    date: '',
  });

  getDate(date) {
    return getDateHelper(date);
  }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
  }

  inputChange(event) {
    this[event] = false;
  }

  searchProduct(event) {
    this.products = [];
    this.isLoading = true;
    this.searchProductChange$.next(event);
  }

  productChange(event) {
    this.validProduct = false;
    // tslint:disable-next-line:triple-equals
    if (event == 2) {
      this.products = [];
      this.searchProductChange$.next('');
      this.showInputProduct = true;
      return;
    }
    this.showInputProduct = false;
  }

  // end san pham

  // khu vuc
  cityChange(event) {
    this.validCity = false;
    // tslint:disable-next-line:triple-equals
    if (event == 2) {
      this.loadCity();
      this.showInputCity = true;
      return;
    }
    this.showInputCity = false;
  }

  changeSelectValue(event) {
    this[event] = false;
  }

  loadCity() {
    this.rootService.listCities().subscribe(
      res => {
        this.cities = res.data.items;
      }
    );
  }

  isNotSelectedCity(value: string): boolean {
    return this.listOfSelectedValueCity.indexOf(value) === -1;
  }

  // end khu vuc
  create() {
    // tslint:disable-next-line:forin
    for (const i in this.form_create.controls) {
      this.form_create.controls[i].markAsDirty();
      this.form_create.controls[i].updateValueAndValidity();
    }
    if (this.form_create.invalid) {
      return;
    }
    this.validName = false;
    const data = this.form_create.value;
    if (data.name.trim().length === 0) {
      this.messageName$ = 'Tên nhóm đối tượng không hợp lệ';
      this.validName = true;
    }
    if (data.name.trim().length > 255) {
      this.messageName$ = 'Tên nhóm đối tượng không quá 255 ký tự';
      this.validName = true;
    }
    const body = {
      name: capitalizeFirstLetter(removeAllSpacingBetweenWords(data.name)),
      isAllProduct: true,
      productIds: [],
      isAllProvince: true,
      provinceIds: [],
      timeAt: data.date ? this.getDate(data.date) : '',
    };
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (this.productValue != 1) {
      if (this.listOfSelectedValueProduct.length > 0) {
        body.isAllProduct = false;
        body.productIds = this.listOfSelectedValueProduct;
        this.validProduct = false;
      } else {
        this.validProduct = true;
        this.messageProduct$ = 'Chưa chọn sản phẩm';
      }
    }
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (this.cityValue != 1) {
      if (this.listOfSelectedValueCity.length > 0) {
        // tslint:disable-next-line:triple-equals
        this.validCity = false;
        // tslint:disable-next-line:triple-equals
        if (this.listOfSelectedValueCity.length != this.cities.length) {
          body.isAllProvince = false;
          body.provinceIds = this.listOfSelectedValueCity;
        }
      } else {
        this.validCity = true;
        this.messageCity$ = 'Chưa chọn khu vực';
      }
    }
    if (this.validName || this.validProduct || this.validCity) {
      return;
    }
    this.loading = true;
    this.customerService.createGroup(body).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Thêm mới nhóm đối tượng thành công'
          );
          setTimeout(() => {
            this.show = false;
          }, 500);
          this.emitData.emit(res.code);
          return;
        }
        this.notification.create(
          'error',
          'Thêm mới nhóm đối tượng thất bại',
          res.message
        );
      },
      error => {
        this.loading = false;
        this.notification.create(
          'error',
          'Thêm mới nhóm đối tượng thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  showModal() {
    this.show = true;
    this.productValue = '1';
    this.showInputProduct = false;
    this.cityValue = '1';
    this.showInputCity = false;
    this.form_create.reset();
    this.products = [];
    this.cities = [];
    this.listOfSelectedValueCity = [];
    this.listOfSelectedValueProduct = [];
  }

  hideModal() {
    this.show = false;
    this.loading = false;
    this.form_create.reset();
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
